import React, {Component, PropTypes} from 'react'
import cx from 'classnames'
import DashboardPanel from './DashboardPanel'
import style from './PercentageDashboardPanel.less'

function metricFilter(total, identify) {
    return (metric) => {
        // keep only metrics with percentage > 0
        return Math.round(identify(metric) * 100 / total) > 0
    }
}

class PercentageDashboardPanel extends Component {
    static propTypes = {
        display: PropTypes.func,
        identify: PropTypes.func,
        total: PropTypes.number,
        onClick: PropTypes.func,
        value: PropTypes.array
    }

    static defaultProps = {
        display: (v) => v,
        identify: (v) => v,
        value: []
    }

    constructor(props) {
        super(props)

        this.state = {
            metrics: []
        }
    }

    componentWillMount() {
        const {identify, value, total} = this.props

        const metricTotal = total || value.reduce((r, v) => r + identify(v), 0)
        const filteredMetrics = total && value || value.filter(metricFilter(metricTotal, identify))
        const metrics = filteredMetrics.sort((a, b) => identify(b) - identify(a))
        this.setState({metricTotal, metrics})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value != this.props.value
            || nextProps.total != this.props.total) {
            const {identify, value, total} = nextProps

            const metricTotal = total || value.reduce((r, v) => r + identify(v), 0)
            const filteredMetrics = total && value || value.filter(metricFilter(metricTotal, identify))
            const metrics = filteredMetrics.sort((a, b) => identify(b) - identify(a))
            this.setState({metricTotal, metrics})
        }
    }

    _percentage(metric) {
        const {identify} = this.props
        const {metricTotal} = this.state
        return Math.round(identify(metric) * 100 / metricTotal)
    }

    render() {
        const {display, identify, filter, onClick, value, total, ...others} = this.props
        const {metrics} = this.state

        const colorClass = (index) => {
            return 'color' + ((index & 0x7) + 1) // bucket in the range 1-8
        }

        return (
            <DashboardPanel
                {...others}>
                <ul className={style.metricGroup}>
                    {metrics.map((metric, index) => (
                        <li
                            key={index}>
                            <div className={style.container}>
                                {onClick && (
                                    <a
                                        href=''
                                        onClick={(e) => onClick(e, metric)}>
                                        <span>{display(metric)}</span>
                                        {!total && (
                                            <span> ({identify(metric)})</span>
                                        )}
                                    </a>
                                ) || (
                                    <div>
                                        <span>{display(metric)}</span>
                                        {!total && (
                                            <span> ({identify(metric)})</span>
                                        )}
                                    </div>
                                )}
                            </div>
                            <div className={style.progress}>
                                <div
                                    className={cx(style.progressBar, style[colorClass(index)])}
                                    style={{width: this._percentage(metric) + '%'}}>
                                    <span>{this._percentage(metric)} %</span>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </DashboardPanel>
        )
    }
}

export default PercentageDashboardPanel


// WEBPACK FOOTER //
// ./lib/core/components/PercentageDashboardPanel.js